import * as React from 'react';

const Lock = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="32" height="32" rx="4" fill="#F2F4F7" />
    <path
      d="M12.0625 14V12.6875C12.0625 10.5273 13.8125 8.75 16 8.75C18.1602 8.75 19.9375 10.5273 19.9375 12.6875V14H20.375C21.332 14 22.125 14.793 22.125 15.75V21C22.125 21.9844 21.332 22.75 20.375 22.75H11.625C10.6406 22.75 9.875 21.9844 9.875 21V15.75C9.875 14.793 10.6406 14 11.625 14H12.0625ZM13.8125 14H18.1875V12.6875C18.1875 11.4844 17.2031 10.5 16 10.5C14.7695 10.5 13.8125 11.4844 13.8125 12.6875V14Z"
      fill="#98A2B3"
    />
  </svg>
);
export default Lock;
